import { ChangeEventHandler, FC, ReactNode } from 'react';

import { useComponentId } from '@telialt/utils/src/hooks';

import { CapsuleShapedCheckbox, IconX } from './ChipFilter.styles';

type ChipFilterProps = {
    children: ReactNode;
    value: string;
    name: string;
    checked?: boolean;
    disabled?: boolean;
    onChange?: ChangeEventHandler<HTMLInputElement>;
};

export const ChipFilter: FC<ChipFilterProps> = ({ children, value, name, checked, disabled, onChange }) => {
    const id = useComponentId('filter-chip');

    return (
        <CapsuleShapedCheckbox>
            <input
                type="checkbox"
                name={name}
                id={id}
                value={value}
                checked={checked}
                disabled={disabled}
                onChange={onChange}
            />
            <label htmlFor={id}>
                {children}
                <IconX />
            </label>
        </CapsuleShapedCheckbox>
    );
};
